<template src="./paladin-report.html"></template>

<script>
import moment from 'moment'

export default {
  components: { },
  props: {
    reportData: {
      type: Array,
      default: null,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    computedReportData() {
      return this.reportData
        ? this.reportData.map((dataPoint) => {
            let _row = { }

            if(dataPoint.entity)
            {
              _row.entity_name = dataPoint.entity.entity.name
            }
            else
            {
              _row.when = moment(String(dataPoint.pointInTime)).format("dddd, MMMM Do YYYY, h:mm:ss a")
            }

            if(dataPoint.sum)
            {
              dataPoint.sum.forEach(function (value){
                _row['Sum: ' + value.property] = value.value
              })
            }

            if(dataPoint.average)
            {
              dataPoint.average.forEach(function (value){
                _row['Average: ' + value.property] = value.value
              })
            }

            if(dataPoint.count)
            {
              dataPoint.count.forEach(function (value){
                _row['Count: ' + value.property] = value.value
              })
            }

          return _row
          })
        : []
    },
  },
  watch: {
  },
  created: function() {
  },
  mounted() {
    this.$nextTick(function() {
      this.init()
    })
  },
  methods: {
    init() {
    },
    closeReport()
    {
      this.$emit('close')
    },
    downloadCsv()
    {
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += [
        Object.keys(this.computedReportData[0]).join(","),
        ...this.computedReportData.map(item => Array.from(Object.values(item),
        (x) => x.toString().includes(',') ? '"' + x.toString() + '"' :x).join(","))
      ]
        .join("\n")
        .replace(/(^\[)|(\]$)/gm, "");

      const data = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", data);
      link.setAttribute("download", "export.csv");
      link.click();
    },
  },
}
</script>

<style lang="scss"></style>
